import { Component } from '@angular/core';
import { ColumnHtmlDto } from 'webcommon/shared';
import { ApColumnBase } from './ap-column-base';

@Component({
  selector: 'ap-column-html',
  templateUrl: './ap-column-html.component.html',
})
export class ApColumnHtmlComponent extends ApColumnBase<ColumnHtmlDto> {
  html: string;

  load(): void {
    this.html = this.columnInfoDto.GetHtmlCallback
      ? this.columnInfoDto.GetHtmlCallback(this.dataItem)
      : '';
  }
}
